import { lazy, Suspense } from 'react'
import { Routes, Route } from 'react-router-dom'
import { Box, CircularProgress } from '@mui/material'
import Homepage from '@/pages/public/home'
import PurchasePortal from '@/pages/payments/PurchasePortal'
import Layout from '@/components/layout/MainLayout/Layout'
import LoginForm from '@/pages/auth/Login'
import InstitutionalPage from '@/pages/public/institutional/institutional'
import UserProfile from '@/pages/auth/MyProfile'
import CreateAccountForm from '@/pages/auth/attendant/Register'
import PaymentsPanel from '@/pages/payments/PaymentsPanel'
import Documents from '@/pages/documents/Documents'
import NewsAndEventsManagement from '@/pages/admin/content/components/AdminContent'
import { GuardRoute } from './GuardRoute'
import { UserRole } from '@/types'
import { DOCUMENTS_Feature, LOGIN_Feature, MEDIA_Feature, PAYMENTS_PANEL_Feature, PAYMENTS_PORTAL_Feature as PAYMENTS_PORTAL_Feature } from '@/features.config'
import CampusGallery from '@/pages/public/campus/CampusGallery'
import PurchaseItemManager from '@/pages/admin/purchaseItem/AdminPurchaseItems'
import MyPurchases from '@/pages/mypurchases/MyPurchases'
import { editorContentEmailException, mediaEmailException } from '@/utils/permissions'

const AdminMedia = lazy(() => import('@/pages/admin/media/AdminMedia'))

const SuspenseFallback = () => (
  <Box display="flex" justifyContent="center" alignItems="center" minHeight="60vh">
    <CircularProgress />
  </Box>
)

export const AppRouter = () => {
  return (
    <Layout>
      <Routes>
        {/* Public routes */}
        <Route path="/" element={<Homepage />} />
        <Route path="/institutional" element={<InstitutionalPage />} />
        <Route path="/sites" element={<CampusGallery />} />
        <Route path="/login" element={<LoginForm />} />
        {LOGIN_Feature && LOGIN_Feature === 'true' && <Route path="/register" element={<CreateAccountForm />} />}


        {/* Protected routes */}
        <Route
          path="/myprofile"
          element={
            <GuardRoute>
              <UserProfile />
            </GuardRoute>
          }
        />
        {PAYMENTS_PANEL_Feature && PAYMENTS_PANEL_Feature === 'true' &&
          <Route
            path="/payments/panel"
            element={
              <GuardRoute allowedRoles={[UserRole.SUPERADMIN]} allowedEmails={editorContentEmailException}>
                <PaymentsPanel />
              </GuardRoute>
            }
          />
        }
        {DOCUMENTS_Feature && DOCUMENTS_Feature === 'true' &&
          <Route
            path="/documents"
            element={
              <GuardRoute allowedRoles={[UserRole.ADMIN, UserRole.EDUCATOR, UserRole.DIRECTIVE,UserRole.SUPERADMIN]}>
                <Documents />
              </GuardRoute>
            }
          />
        }
        <Route
          path="/payments/portal"
          element={
            <PurchasePortal />
          }
        />
        <Route path='/admin/content'
          element={
            <GuardRoute allowedRoles={[UserRole.SUPERADMIN, UserRole.DIRECTIVE]} allowedEmails={editorContentEmailException}>
              <NewsAndEventsManagement />
            </GuardRoute>
          }
        />
        {MEDIA_Feature && MEDIA_Feature === 'true' &&
          <Route
            path="/admin/media"
            element={
              <GuardRoute allowedRoles={[UserRole.SUPERADMIN, UserRole.DIRECTIVE]} allowedEmails={mediaEmailException}>
                <Suspense fallback={<SuspenseFallback />}>
                  <AdminMedia />
                </Suspense>
              </GuardRoute>
            }
          />
        }
        <Route
          path="/admin/purchaseItem"
          element={
            <GuardRoute allowedRoles={[UserRole.SUPERADMIN]} allowedEmails={editorContentEmailException}>
              <PurchaseItemManager/>
            </GuardRoute>
          }
        />
        {PAYMENTS_PORTAL_Feature && PAYMENTS_PORTAL_Feature === 'true' &&
          <Route
            path="/mypurchases"
            element={
              <GuardRoute>
                <MyPurchases />
              </GuardRoute>
            }
          />
        }

        <Route path="*" element={<div>404 - Page Not Found</div>} />
      </Routes>
    </Layout>
  )
}
